import { takeEvery } from 'redux-saga/effects';
import { EKYC_INFO_FETCH, EKYC_KYC_FILE_RETRIEVE_FETCH, EKYC_LIST_FETCH } from '../constants';
import { ekycListSaga, ekycInfoSaga, ekycFileRetrieveSaga } from './ekycSagas';

export function* rootEkycSaga() {
  yield takeEvery(EKYC_LIST_FETCH, ekycListSaga);
  yield takeEvery(EKYC_INFO_FETCH, ekycInfoSaga);
  yield takeEvery(EKYC_KYC_FILE_RETRIEVE_FETCH, ekycFileRetrieveSaga);
}
